const DATE_TIME_FORMATTER = new Intl.DateTimeFormat('ko-KR', {
  dateStyle: 'medium',
  timeStyle: 'short',
});

const DATE_FORMATTER = new Intl.DateTimeFormat('ko-KR', { dateStyle: 'medium' });

const KO_NUMBER_FORMATTER = new Intl.NumberFormat('ko-KR');

/** 원 단위 정수를 "8,900원" 형태로 변환한다. */
export const formatKrw = (amount: number): string => `${KO_NUMBER_FORMATTER.format(amount)}원`;

/** 수량·개수를 "1,000" 형태로 변환한다 — 단위(개·종 등)는 호출부가 붙인다. */
export const formatCount = (value: number): string => KO_NUMBER_FORMATTER.format(value);

/** 가로·세로 mm 를 "100 × 60 mm" 형태로 변환한다 — 소수 첫째 자리까지, 끝의 0 은 뗀다. */
export const formatMmSize = (widthMm: number, heightMm: number): string =>
  `${Number(widthMm.toFixed(1))} × ${Number(heightMm.toFixed(1))} mm`;

/** Date 또는 ISO 문자열을 한국어 로캘 문자열로 변환한다. */
export const formatDateTime = (value: Date | string): string => {
  const date = value instanceof Date ? value : new Date(value);

  if (Number.isNaN(date.getTime())) {
    return '-';
  }

  return DATE_TIME_FORMATTER.format(date);
};

/** Date 또는 ISO 문자열을 시각 없이 날짜만("2026. 10. 12.") 한국어 로캘 문자열로 변환한다. */
export const formatDate = (value: Date | string): string => {
  const date = value instanceof Date ? value : new Date(value);

  if (Number.isNaN(date.getTime())) {
    return '-';
  }

  return DATE_FORMATTER.format(date);
};

const CALENDAR_DATE = /^(\d{4})-(\d{2})-(\d{2})$/;

/**
 * YYYY-MM-DD 달력 날짜(유효기한·출고 예정일·환급 기한 등)를 시간대 변환 없이 "2026. 10. 19." 로 적는다 —
 * formatDate 와 같은 모양이지만 자정 UTC 로 읽혀 날짜가 밀리는 일이 없다. 형식이 다르면 "-" 를 반환한다.
 */
export const formatCalendarDate = (value: string): string => {
  const match = CALENDAR_DATE.exec(value);

  if (match === null) {
    return '-';
  }

  const [, year, month, day] = match;
  return `${year}. ${Number(month)}. ${Number(day)}.`;
};
